export const BRAND_NAME = 'NearHub';
export const BRAND_TAGLINE = 'Buy, Sell & Discover Local Deals Near You';
export const BRAND_SIGNATURE = `${BRAND_NAME} – ${BRAND_TAGLINE}`;
